/**
 * Transport for the staff product-category tree (line / family / sub-family).
 * Shared by ProductCategoryManagement's CRUD tree and ProductCategorySelect's
 * read-only line/family/sub-family picker.
 */
// eslint-disable-next-line no-restricted-imports -- api-layer module under a legacy filename, not literally api.js
import apiClient from '@sophocles/http-common';

export const PRODUCT_CATEGORY_ENDPOINTS = {
  'product-line': '/warehouse/product-lines/',
  'product-family': '/warehouse/product-families/',
  'product-sub-family': '/warehouse/product-sub-families/',
};

export const fetchProductLines = () => apiClient.get(PRODUCT_CATEGORY_ENDPOINTS['product-line']).then(res => res.data);

export const saveProductCategoryItem = (url, payload, isNew) =>
  apiClient[isNew ? 'post' : 'put'](url, payload).then(res => res.data);

export const deleteProductCategoryItem = url => apiClient.delete(url);
